import COLORS from 'themes/colors';
import { createStylesWithTheme } from 'utils/functions';

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    maxWidth: 583,
    alignSelf: "center",
    width: "100%",
    textAlign: "center",
  },
  header: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "8px",
    marginBottom: 24,
  },
  inputContainer: {
    marginTop: 8,
    marginBottom: 16,
  },
  inputLabel: {
    marginTop: 16,
    marginBottom: 8,
    display: 'flex',
    justifyContent: 'flex-start',
  },
  tooltip: {
    paddingLeft: 4,
    color: COLORS.LIGHT_NEUTRALS[900]
  }
};

export default createStylesWithTheme(styles);